import PropTypes from 'prop-types';
import React from 'react';

import { BadgeTypes } from '../../../../constants/Badge';
import Badge from '../../Badge/Badge';

import './RowItemCollectedBadge.scss';

const RowItemCollectedBadge = React.memo(({ isCollected, isRowSmall }) => {
  if (isCollected && !isRowSmall) {
    return (
      <div className='RowItemCollectedBadge'>
        <Badge badgeType={BadgeTypes.COLLECTED} isIcon={true} />
      </div>
    );
  }

  return null;
});

RowItemCollectedBadge.propTypes = {
  isCollected: PropTypes.bool,
  isRowSmall: PropTypes.bool,
};

export default RowItemCollectedBadge;
